var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 88,
    viewBox: "0 0 376 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4587 0.5V55.3557H64.3489V21.835L60.941 19.1955L60.6133 4.99372L64.3489 0.5H87.4587Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.453 87.3624H64.3489V58.9588H87.4587V64.5213H102.057V0.5H125.085V39.7289L125.052 55.5906L123.913 56.7079V84.2694L126.453 87.3624Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.054 62.6186V87.3705H129.672L128.304 85.7025L127.133 84.2694L126.969 57.7524L128.14 56.5946L129.509 55.2262L162.916 23.3491H128.485V0.5H161.22L164.89 3.08288H183.158L185.772 0.5H189.728V28.9116L152.979 64.5213H167.225V58.9588H190.244L190.728 59.5904L193.054 62.6186Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.823 28.9116L216.557 64.5213H230.795V58.9588H253.823V87.3705H196.552L196.561 62.4485L193.644 58.6511L193.53 55.6634L206.596 42.8543H209.594L220.359 32.2151L221.014 28.7173L226.494 23.3491H193.087V0.5H253.823V28.9116Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5 23.3491H349.572L367.414 40.9839V58.9588H344.477V64.5213H375.5V87.3705H321.899L323.39 86.245V68.9503L321.359 67.1285V58.9588H344.387V50.4491L321.359 27.689V0.5H375.5V23.3491Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.431 0.5V54.1817H271.125L270.208 55.0805H257.313V0.5H280.431Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.925 69.3308V85.6863L318.041 87.3705H291.925L289.967 85.4353H265.309L262.515 87.3705H257.305V57.55H270.625L271.657 56.5136H280.431V64.5213H295.029V36.1178H310.775L318.041 43.9393V67.4686L319.925 69.3308Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2278 23.341V58.9588H23.618V69.3632L21.7174 71.1445V87.3624H4.8336L0.5 79.889V31.1625H23.618V36.1097H38.2081V23.341H27.9188L23.9703 27.2518H0.5V8.29721L7.78275 0.5H60.343L57.5004 3.76301L57.7871 20.1752L61.2278 23.341Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.644 87.3705L324.513 87.5V87.3705H324.644Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleLogo);
export default __webpack_public_path__ + "static/media/puzzle_logo.26ab57159d6c0b142c4e0bfa86baef5a.svg";
export { ForwardRef as ReactComponent };